import React from "react";

const Catalog = ({ data }) => (
	<div>
		{data.title && <h2>{data.title}</h2>}
		<div className="w-full h-[70vh] md:h-[90vh]">
			<iframe
				allowFullScreen={true}
				style={{ width: "100%", height: "100%", border: "none" }}
				src={data.src}
				title="Embedded Iframe"
			></iframe>
		</div>
	</div>
);

export default Catalog;